import styles from '../../index.module.scss';
import type { TimeRuleChat } from '../useTimeRuleChat';
import type { TimeRuleType } from '../types';

const TYPE_LABELS: { value: TimeRuleType; label: string; hint: string }[] = [
	{ value: 'split', label: 'Split', hint: 'Divide each matching time entry across customer/class by percentage.' },
	{ value: 'edit', label: 'Edit', hint: 'Rewrite the customer or class on matching time entries.' },
	{ value: 'delete', label: 'Delete', hint: 'Zero out matching time entries.' },
];

export default function DetailsCard({ chat }: { chat: TimeRuleChat }) {
	const { details, error } = chat;
	const selected = TYPE_LABELS.find((entry) => entry.value === details.ruleType);

	return (
		<div className={styles['action-card']}>
			<div className={styles['action-card__summary']}>Name the time rule, then I&apos;ll open the form</div>

			<div className={styles['rule-form']}>
				<label className={styles['rule-form__field']}>
					<span className={styles['rule-form__label']}>Rule name</span>
					<input
						className={styles['rule-form__input']}
						value={details.name}
						placeholder="e.g. Recode Hugo's admin time"
						onChange={(e) => chat.patchDetails({ name: e.target.value })}
					/>
					{error && <span className={styles['rule-form__error']}>{error}</span>}
				</label>

				<label className={styles['rule-form__field']}>
					<span className={styles['rule-form__label']}>Description (optional)</span>
					<input
						className={styles['rule-form__input']}
						value={details.description}
						placeholder="What this rule is for"
						onChange={(e) => chat.patchDetails({ description: e.target.value })}
					/>
				</label>

				{/* Collected here rather than in the modal because it decides which
				    tab opens, and the modal takes the rule's type from the open tab. */}
				<label className={styles['rule-form__field']}>
					<span className={styles['rule-form__label']}>Rule type</span>
					<select
						className={styles['rule-form__input']}
						value={details.ruleType}
						onChange={(e) => chat.patchDetails({ ruleType: e.target.value as TimeRuleType })}
					>
						{TYPE_LABELS.map((entry) => (
							<option key={entry.value} value={entry.value}>
								{entry.label}
							</option>
						))}
					</select>
					{selected && <span className={styles['rule-form__hint']}>{selected.hint}</span>}
				</label>

				<span className={styles['rule-form__hint']}>
					Next you&apos;ll set what it matches, and the split or replacement details — in Settings → Time Rules.
					These rules are company-wide, not per pay period.
				</span>
			</div>

			<div className={styles['action-card__buttons']}>
				<button type="button" className={styles['action-card__confirm']} onClick={chat.handOff}>
					Open rule form
				</button>
			</div>
		</div>
	);
}
